import { FC } from 'react'
import { useTheme } from '@emotion/react'

// icons
import { icons } from '@/assets'
// hooks
import { useAppDispatch } from '@/hooks'
// features
import { postClosePostDeleteModal } from '@/features'
// components
import { CardHeaderMobile, ModalCardTitle, ModalCardSubtitle, Error } from '@/components'

// components
import { PostDeleteForm } from './components'
// styles
import { styles } from './styles'

type PostDeleteCardProps = {}

export const PostDeleteCard: FC<PostDeleteCardProps> = () => {
  const theme = useTheme()

  const dispatch = useAppDispatch()
  const postDeleteError = ''

  return (
    <div
      css={styles(theme).card.main}
      onClick={(e) => e.stopPropagation()}
      aria-hidden="true"
    >
      {/* mobile header */}
      <div css={styles(theme).card.header}>
        <CardHeaderMobile onCloseClick={() => dispatch(postClosePostDeleteModal())} />
      </div>

      {/* title */}
      <div css={styles(theme).card.title}>
        <ModalCardTitle text="Delete Post" icon={icons.Trash} />
      </div>

      {/* subtitle */}
      <div css={styles(theme).card.subtitle}>
        <ModalCardSubtitle text="Are you sure you want to delete your post?" />
      </div>

      <div css={styles(theme).card.content.main}>
        {/* form */}
        <div css={styles(theme).card.content.form}>
          <PostDeleteForm />
        </div>

        <div css={styles(theme).card.content.error}>
          <Error error={postDeleteError} />
        </div>
      </div>
    </div>
  )
}

PostDeleteCard.propTypes = {}
